module.exports = "https://r.zoocdn.com/_next/static/images/landing-pages-coast-851a270584d585b8e4cc9cb24dc820a7.svg";